import React, { Component, ReactElement } from 'react';

import { VideoStreamAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, Value } from '@philips-emr/tws-core';
import { expression, object, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { getResolvedPathAndParameters, isPathReady } from '@philips-emr/tws-core/lib/util';

import './video-stream.css';

export interface VideoStreamProps {
  data: Record<string, Value>;
  endpoint: string;
  title: string;
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: VideoStreamAPI })
class VideoStream extends Component<VideoStreamProps> {
  static propTypes = {
    data: object,
    endpoint: string,
    title: expression,
  };

  static defaultProps = {
    data: {},
    endpoint: '',
    title: 'tws.video-stream.title',
  };

  renderStream(): ReactElement | null {
    const { endpoint, data } = this.props;

    const { resolvedPath } = getResolvedPathAndParameters(endpoint, data);

    if (!endpoint || !isPathReady(resolvedPath)) {
      return null;
    }

    return (
      <iframe
        allow="camera;microphone;fullscreen;speaker"
        className="c-video-stream__iframe"
        frameBorder={0}
        src={resolvedPath}
      />
    );
  }

  render(): ReactElement {
    const { title } = this.props;

    return (
      <div className="c-video-stream">
        <div className="c-video-stream__title">
          {msg(title)}
        </div>
        <div className="c-video-stream__stream">
          {this.renderStream()}
        </div>
      </div>
    );
  }
}

export default VideoStream;
